<template>
  <v-container>
    <v-layout row>
      <v-flex shrink class="dep_date">
        <div class="head_lg date">
          Departure Date
        </div>
        <v-text-field
          :value="dep_date"
          :rules="depDateRules"
          :clearable="false"
          :show-current="false"
          @focus="calDep = true"
          :append-icon="calDep ? 'close' : ''"
          @click:append="hideCalDep"
          mask="####-##-##"
          :return-masked-value="true"
          outline
        ></v-text-field>
        <v-date-picker
          ref="dep_date_picker"
          v-show="calDep === true"
          v-model="dep_date"
          type="date"
          full-width
          :landscape="false"
          format="yyyy-MM-dd"
          :allowedDates="enabledDates"
          max-width="250px"
          @input="handleInput()"
          :reactive="true"
        >
        </v-date-picker>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Vue from "vue";
import Shared from "@/mixins/Shared";
import { createHelpers } from "vuex-map-fields";
const { mapFields } = createHelpers({
  getterType: "getField"
});

export default {
  name: "DepartureDateSelect",
  mixins: [Shared],
  data() {
    return {
      calDep: false
    };
  },
};
</script>
